export const numberFormat = (value?: string | number | null, count: number = 3, separator: string = ",") => {
	if (typeof value === "undefined" || value === null) return value;

	if (typeof value === "number") value = String(value);
	const objRegex = new RegExp("(-?[0-9]+)([0-9]{" + count + "})");
	let val = value.replace(/[^0-9-]/gi, "");
	while (objRegex.test(val)) {
		val = val.replace(objRegex, "$1" + separator + "$2");
	}
	return val;
};

export const uniqueByKey = <T>(array: T[], key: string): T[] => {
	return [...new Map(array.map((item) => [item[key], item])).values()];
};

export const e2p = (s: string | number) => s.toString().replace(/\d/g, (d: string) => "۰۱۲۳۴۵۶۷۸۹"[+d]);
export const p2e = (s: string | number) => s.toString().replace(/[۰-۹]/g, (d: string) => String("۰۱۲۳۴۵۶۷۸۹".indexOf(d)));

export const pickFirst = <T extends string | undefined | null>(...vals: T[]): string | undefined => {
	return vals.find((v) => typeof v === "string" && v.trim() !== "") as string | undefined;
}